






































































































































import { Vue, Prop, Component } from 'vue-property-decorator';
import DateFormat from '@/shared/utils/date-format';
import toCurrency from '@/shared/directive/toCurrency';
import toDocument from '@/shared/directive/toDocument';
import routeTo from '@/router/routeTo';
import BillingDetailed from '@/domain/billing/entity/billing-detailed.entity';
import ItemsDetailed from '@/domain/billing/entity/billing-detailed-entitys.ts/items-detailed.entity';

@Component({
  filters: {
    dayMonthYear(date: string): string {
      if (date === undefined || date === '' || date === ' ' || date === null) return '—';
      return DateFormat.timestampToLocal(date.substr(0, 10));
    },
    toDocument,
  },
})
export default class BillingInfoV2Summary extends Vue {
  @Prop({
    required: true,
  })
  billing!: BillingDetailed;

  @Prop({
    required: false,
    default: '',
  })
  businessUnitId!: string;

  get isContractSameBusinessUnit(): boolean {
    return this.billing.items.every((item: ItemsDetailed) => item.businessUnitId
      === this.businessUnitId);
  }

  get businessUnitName(): string {
    return this.billing.items[0]?.businessUnitName || '';
  }

  money(value: string): string {
    return toCurrency(value, this.billing.currency.name, this.billing.currency.symbol);
  }

  goToContract(): void {
    routeTo(this.$router, { path: `/contract/${this.billing.contracts[0].id}` });
  }
}
